import { Factory } from 'miragejs'

export const suggestedTopic = Factory.extend({
  name(i) {
    const values = [
      'Recognising the Signs of Brain Haemorrhage',
      'How to Prevent Brain Haemorrhage',
      'How to prevent brain issues',
      'What to do if you have a brain haemorrhage',
    ]
    return values[i % values.length]
  },
  domain: {
    id: '1',
    domain_url: 'www.practo.in',
  },
  keywords(i) {
    const values = [
      ['Bladder Health', 'Bladder Care', 'Bladder Cancer'],
      ['Health Tips', 'Neurology'],
      ['Bladder Care'],
    ]
    return values[i % values.length]
  },
  expected_traffic_start: 12300,
  expected_traffic_end: 15000,
  created_at(i) {
    const values = [
      new Date('2023-07-01').toISOString(),
      new Date('2023-05-04').toISOString(),
      new Date('2023-08-07').toISOString(),
    ]
    return values[i % values.length]
  },
  updated_at(i) {
    const values = [
      new Date('2023-07-01').toISOString(),
      new Date('2023-05-04').toISOString(),
      new Date('2023-08-07').toISOString(),
    ]
    return values[i % values.length]
  },
})
